import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './ExpandableText.css';

interface ExpandableTextProps {
  text: string;
  maxLines?: number;
  maxLength?: number;
  className?: string;
}

const ExpandableText: React.FC<ExpandableTextProps> = ({
  text,
  maxLines = 2,
  maxLength = 120,
  className = ''
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  // Check if text needs "See more" functionality
  const needsExpansion = useMemo(() => {
    if (!text) return false;
    const lines = text.split('\n');
    return lines.length > maxLines || text.length > maxLength;
  }, [text, maxLines, maxLength]);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  if (!text) return null;

  return (
    <div className={`expandable-text ${className}`}>
      <div className={`expandable-text-content ${isExpanded ? 'expanded' : ''}`}>
        {text}
      </div>
      {needsExpansion && (
        <span className="expandable-text-toggle" onClick={handleToggle}>
          {isExpanded ? t('#Task.see_less') : t('#Task.see_more')}
        </span>
      )}
    </div>
  );
};

export default ExpandableText;